import { connect } from 'react-redux';
import LinkWrapper from 'components/LinkWrapper';
import { selectRouter } from 'modules/App/utils/selectors';

const mapStateToProps = (state) => ({
  router: selectRouter(state),
});

export default connect(mapStateToProps)(LinkWrapper);
